<div class="product-page" *ngIf="product">

    <div class="product-wrapper">

        <!-- LEFT -->

        <div class="gallery">

            <div class="main-image">

                <img
                    [src]="selectedImage || product.mainImage"
                    [alt]="product.name">

            </div>

         <div class="thumbs">

            <img
                *ngFor="let image of product.images"
                [class.active]="selectedImage === image.imageUrl"
                [src]="image.imageUrl"
                [alt]="product.name"
                (click)="selectImage(image.imageUrl)">

        </div>

        </div>

        <!-- RIGHT -->

        <div class="details">

            <h1>{{ product.name }}</h1>

            <p>{{ product.description }}</p>

            <ul>

                <li>{{ product.material }}</li>

                <li>{{ product.maintenance }}</li>

                <li>Veličine: {{ product.sizes }}</li>

                <li>Boje: {{ product.colors }}</li>

            </ul>

           <button
    class="btn-main"
    (click)="goToContact()">

    Pošalji upit

</button>

        </div>

    </div>

</div>